import { DataConnectorType } from "@/api/data-connectors";
import { CreateDataConnectorData } from "@/data-connectors/api";
import { Badge } from "@/design-system/components/Badge/Badge";
import { useMultistepContext } from "@/design-system/components/BottomDrawerMultistepModal/context";
import { Card } from "@/design-system/components/Card";
import { Input } from "@/design-system/components/Input/Input";
import { Radio } from "@/design-system/components/Radio/Radio";
import { RadioGroup } from "@/design-system/components/Radio/RadioGroup";

interface DataConnectorTypeOption {
  type: DataConnectorType;
  label: string;
  description: string;
}

const options: Array<DataConnectorTypeOption> = [
  {
    type: "api",
    label: "API",
    description:
      "Push data into Freshpaint from your systems using the Freshpaint API.",
  },
  {
    type: "airbyte",
    label: "Airbyte",
    description:
      "Let Freshpaint pull data from your systems through an Airbyte connection.",
  },
];

export function DataConnectorDetailsForm() {
  const { data, setData } = useMultistepContext<CreateDataConnectorData>();

  return (
    <div className="flex max-w-5xl flex-col gap-4">
      <Card headerText="Data Connector Details" className="max-w-xl">
        <Input
          name="name"
          label="Name"
          value={data.name}
          onChange={(e) => setData({ ...data, name: e.target.value })}
        />
      </Card>

      <Card headerText="Data Connector Type" className="max-w-xl">
        <RadioGroup
          value={data.type}
          onValueChange={(value) =>
            setData({ ...data, type: value as DataConnectorType })
          }
        >
          {options.map(({ type, label, description }) => (
            <Radio
              key={type}
              value={type}
              label={
                type === "api" ? (
                  label
                ) : (
                  <span className="flex flex-auto flex-row gap-3">
                    {label}{" "}
                    <Badge
                      text="Coming Soon"
                      className="min-w-0 px-2 py-0 text-xs"
                    />
                  </span>
                )
              }
              description={description}
              disabled={type !== "api"}
            />
          ))}
        </RadioGroup>
      </Card>
    </div>
  );
}
